var l={ScrollBox:"ScrollBox__ScrollBox-0Bt",vertical:"ScrollBox__vertical-d90",horizontal:"ScrollBox__horizontal-exb"};export{l as default};
